module.exports = __webpack_public_path__ + "static/img/kong.dadc472.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kong/kong.png
// module id = Y55A
// module chunks = 1